import React from 'react';
import cx from 'classnames';

const ModalSection = ({ children, className }) => {
  return <div className={cx('modal-section', className)}>{children}</div>;
};

export default ModalSection;
